<template lang="html">
  <div class="ai-confirm">
    <transition name="fade">
      <div v-if="visible" class="ai-hover" />
    </transition>
    <transition name="top-fade">
      <div v-if="visible" class="ai-confirm__content">
        <div class="ai-confirm-title">
          <img class="ai-confirm-title__icon" :src="require('./warning.svg')">
          <span>{{ title }}</span>
        </div>
        <div class="ai-confirm-content">
          {{ message }}
        </div>
        <div class="ai-confirm-actions">
          <div class="ai-button ai-button--primary" @click="onConfirm">
            确 认
          </div>
          <div class="ai-button" @click="onCancel">
            取 消
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AiConfirm',
  data() {
    return {
      visible: false,
      icon: '',
      title: '',
      message: ''
    };
  },
  mounted() {
    this.visible = true;
  },
  methods: {
    onConfirm() {
      this.removeConfirm();
      if (this.resolve) this.resolve();
    },
    onCancel() {
      this.removeConfirm();
      if (this.reject) this.reject();
    },
    removeConfirm() {
      this.visible = false;
      setTimeout(this.removeNode, 200);
    },
    removeNode() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>
